module.exports = __webpack_public_path__ + "static/media/product_1.2ef05aca.png";